import React from 'react'

import BlogHead from './blogComponents/BlogHead'
import BlogContent from './blogComponents/BlogContent'

const Blog = () => {
  return (
    <div>
      <BlogHead />
      <BlogContent />
    </div>
  )
}

export default Blog;